import { apiFetchJson } from './apiClient';

export interface PrivateCircleApplication {
  first_name: string;
  second_name: string;
  nickname: string;
  company?: string;
  title?: string;
  sector?: string;
  phone?: string;
}

export const privateCircleService = {
  async apply(data: PrivateCircleApplication): Promise<{ success: boolean; message: string }> {
    const result = await apiFetchJson<{ success: boolean; message: string }>(
      'POST',
      '/private-circle/applications',
      { body: data, withAuth: true },
    );
    if (!result.ok) {
      return { success: false, message: result.error };
    }
    return result.data;
  },

  async fetchMyApplication(): Promise<{
    company: string | null;
    title: string | null;
    sector: string | null;
    nickname: string | null;
    first_name: string | null;
    second_name: string | null;
  } | null> {
    const result = await apiFetchJson<{
      data: {
        company: string | null;
        title: string | null;
        sector: string | null;
        nickname: string | null;
        first_name: string | null;
        second_name: string | null;
      } | null;
    }>('GET', '/private-circle/applications/me', { withAuth: true });
    if (!result.ok || !result.data.data) return null;
    return result.data.data;
  },
};
